<template>
  <section class="sal-card">
    <div class="sal-section-head">
      <h1 class="sal-section-title">Parámetros de Producción</h1>
    </div>

    <SALDropdown
      v-model="localForm.producto"
      label="Producto"
      placeholder="Selecciona producto"
      :options="productos"
      :error="errors.producto"
      error-message="Selecciona un producto."
      @select="handleProductoSelect"
    />

    <SALDropdown
      v-model="localForm.color"
      label="Color"
      placeholder="Selecciona color"
      :options="colores"
      :error="errors.color"
      error-message="Selecciona un color."
      @select="handleColorSelect"
    />

    <div class="sal-field">
      <button
        type="button"
        class="sal-aditivo-toggle"
        :class="{ 'is-active': localForm.aditivo }"
        role="switch"
        :aria-checked="localForm.aditivo"
        aria-label="Aditivo"
        @click="toggleAditivo"
      >
        <i
          class="bi"
          :class="localForm.aditivo ? 'bi-check-circle-fill' : 'bi-x-circle'"
          aria-hidden="true"
        ></i>
        <span>{{ localForm.aditivo ? "Con aditivo" : "Sin aditivo" }}</span>
      </button>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";

import SALDropdown from "../components/SALDropdown.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  productos: {
    type: Array,
    default: () => [],
  },
  colores: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function handleProductoSelect(option) {
  localForm.value.productoLabel = option.label;
  notifyFieldChange("producto");
}

function toggleAditivo() {
  localForm.value.aditivo = !localForm.value.aditivo;
  notifyFieldChange("aditivo");
}

function notifyFieldChange(field) {
  emit("field-change", { field });
}

function handleColorSelect(option) {
  localForm.value.colorLabel = option.label;
  localForm.value.colorHex = option.hex || "";
  notifyFieldChange("color");
}
</script>
